import { TRIGGERS } from './actions';
/**
 * A clone of https://github.com/candulabs/service-backend/blob/master/modules/commons/app/ai/candu/models/notebook/schema/Schema.scala
 */
import { FieldTypeSchema } from './propTypeSchema';

export interface Info {
  /** The name of the schema */
  name: string;
  /** The library version */
  version?: string;
}

export type EnumValue = number | string;

export interface EnumValueSchema {
  /** The value of the enum entry */
  value: EnumValue;
  /** A display name for the value */
  name?: string;
}

export interface EnumSchema {
  /** An identifier for the enum */
  id: string;
  /** All the values in the enum */
  values: EnumValueSchema[];
  /** The default value for the enum */
  defaultValue?: EnumValue;
  /** Display name for the enum */
  name?: string;
}

export enum ComponentCategory {
  Atomic = 'Atomic',
  Layout = 'Layout',
  Media = 'Media',
  Typography = 'Typography',
}

export enum NodeLocation {
  Leaf = 'Leaf',
  Internal = 'Internal',
}

export enum EditingMode {
  Toolbox = 'Toolbox',
  Custom = 'Custom',
}

export interface PropSchema<FieldType extends FieldTypeSchema = FieldTypeSchema> {
  /** An identifier for the schema props */
  id: string;
  /** A display name */
  name?: string;
  /** Group name */
  group?: string;
  /** the proptype for the schema */
  fieldType: FieldType;
  /** specifies how the prop should be editing (eg: via the Toolbox) * */
  editingMode: EditingMode;
}

export interface PropToEdit<FieldType extends FieldTypeSchema = FieldTypeSchema> {
  schema: PropSchema<FieldType>;
  value: any;
}

export interface ComponentSchema {
  /** The type of the component we want to render. This is the same as a `block`. */
  type: string;
  /** The category of the node to be rendered */
  category: ComponentCategory;
  /** Whether the node is a leaf or internal */
  location: NodeLocation;
  /** A display name for the component */
  name?: string;

  props?: PropSchema[];

  actions?: TRIGGERS[];
  // TODO type custom
  custom?: any;
}

export interface Schema {
  id: string;
  info: Info;
  enums: EnumSchema[];
  components: ComponentSchema[];
}
